




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Step } from '@/interfaces/Step';

@Component({})
export default class CyclesDialog extends Vue {
  @Prop()
  cycles: any;

  @Prop()
  value?: boolean;

  getStepName(step: Step) {
    const stepLanguage =
      step.stepLanguages.find((sL: any) => sL.langaugeId === this.$store.state.user.languageId) ||
      step.stepLanguages[0];
    return stepLanguage?.name || '';
  }
}
